import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-light-svg-icons';
import { Action } from 'corso-admin-ui';
import { usePaginate } from '~/hooks/usePaginate';
import { formatter } from 'corso-web-lib';

/** Works with `usePaginate` data to render simple pagination controls. */
export default function Paginator<T>({
  pagination,
}: {
  pagination: ReturnType<typeof usePaginate<T>>;
}) {
  const { page, pages, isFirst, isLast, previous, next } = pagination;

  if (pages <= 1) return null;

  return (
    <div className="flex items-center justify-center gap-2">
      <Action
        disabled={isFirst}
        accessibilityLabel="Previous Page"
        variant="ghost"
        icon={faChevronLeft}
        onClick={previous}
      />

      <span className="text-xs text-neutral-500">
        {formatter.count(page + 1)} of {formatter.count(pages)}
      </span>

      <Action
        variant="ghost"
        icon={faChevronRight}
        accessibilityLabel="Next Page"
        onClick={next}
        disabled={isLast}
      />
    </div>
  );
}
